import { CurrencyMap } from "./currencyAction";

const initialState = {
  isLoading: false,
  currencyList: {},
  refreshList: true,
  selectedCurrency: null,
  search: "",
  templates: [],
  searchText: "",
  skip: 0,
  limit: 10,
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case CurrencyMap.GET_ALL_CURRENCY_START: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case CurrencyMap.GET_ALL_CURRENCY_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        currencyList: action.payload,
        refreshList: false,
      };
    }
    case CurrencyMap.GET_ALL_CURRENCY_ERROR: {
      return {
        ...state,
        isLoading: false,
        refreshList: false,
      };
    }
    case CurrencyMap.ADD_CURRENCY_START: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case CurrencyMap.ADD_CURRENCY_SUCCESS: {
      return {
        ...state,
        refreshList: true,
      };
    }
    case CurrencyMap.ADD_CURRENCY_ERROR: {
      return {
        ...state,
        isLoading: false,
        refreshList: false,
      };
    }
    case CurrencyMap.UPDATE_CURRENCY_START: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case CurrencyMap.UPDATE_CURRENCY_SUCCESS: {
      return {
        ...state,
        refreshList: true,
      };
    }
    case CurrencyMap.UPDATE_CURRENCY_ERROR: {
      return {
        ...state,
        isLoading: false,
        refreshList: false,
      };
    }
    case CurrencyMap.GET_ALL_TEMPLATES_START: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case CurrencyMap.GET_ALL_TEMPLATES_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        templates: action.payload,
        refreshList: true,
      };
    }
    case CurrencyMap.GET_ALL_TEMPLATES_ERROR: {
      return {
        ...state,
        isLoading: false,
        templates: [],
        refreshList: false,
      };
    }
    case CurrencyMap.SELECT_CURRENCY_DETAILS: {
      return {
        ...state,
        isLoading: false,
        selectedCurrency: action.payload,
      };
    }
    case CurrencyMap.SEARCH_TEXT_CHANGE: {
      return {
        ...state,
        searchText: action.payload,
      };
    }
    case CurrencyMap.SET_CURRENCY_BATCH_NUMBER: {
      return {
        ...state,
        skip: action.payload,
        refreshList: true,
      };
    }
    case CurrencyMap.REFRESH_CURRENCY_LIST: {
      return {
        ...state,
        skip: 0,
        refreshList: true,
      };
    }
    case CurrencyMap.DELETE_CURRENCY_START: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case CurrencyMap.DELETE_CURRENCY_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        refreshList: true,
      };
    }
    case CurrencyMap.DELETE_CURRENCY_ERROR: {
      return {
        ...state,
        isLoading: false,
        refreshList: false,
      };
    }
    default:
      return { ...state };
  }
};
